// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/5e405b2bd82a29d40231.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"06c878fed8e70d4c7b90","191":"e0a17a2323f41b6cca96","192":"2b0f87c7c2f64f0f4a34"}[chunkId] + ".chunk.js";
};